import { Component, inject, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../shared/components/dialog-header/dialog-header.component";

export interface ConfirmDialogData {
  modalTitle: string;
  modalContent: string;
  confirmMessage?: string;
  cancelMessage?: string | null;
}

@Component({
  selector: "app-confirm-action-modal",
  imports: [MatDialogModule, ButtonComponent, DialogHeaderComponent],
  templateUrl: "./confirm-action-modal.component.html",
  styleUrl: "./confirm-action-modal.component.scss",
})
export class ConfirmActionModalComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmActionModalComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
    // Set defaults for optional properties
    this.data.confirmMessage = data.confirmMessage ?? "Confirmar";
    this.data.cancelMessage = data.cancelMessage ?? "Cancelar";
  }
}
